<template>
    <div class="">

        <!-- Abdullah chnaged this markup with the new markup design this block of dashboard -->
        <div class="company_dashboar_new">
            <div class="ibox col-md-12 border-0 top_container">
                <div class="ibox-title dashboard_title company-form-box-title ">
                    <div class="row no-gutters">
                        <div class="col-sm-6 float-left">
                            <div class="title-text">Dashboard</div>
                        </div>

                        <!-- AbdullahFixed Chnaged here. commented this code  -->
                        <!-- <div class="col-sm-6 search_container">
                            <div class="custom-search">
                                <b-input-group class="mb-0">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.." v-model="dash_search" @input="dashboardSearch()"></b-form-input>
                                </b-input-group>
                            </div>
                            <img v-bind:src="$api_url+'/images/settings_icon.png'"  class="img-fluid settins_icon cursor-pointer"/>
                        </div> -->
                    </div>
                    <div class="row dashboard_overview_card_wrapper">

                            <!-- <div class="col-sm-4">
                                <div class="row">
                                    <div class=" col-sm-12">
                                        <div class="row dashboard_overview_card">
                                            <div class="col-sm-10 first">
                                                <div class="sub-title">Total employees</div>
                                                <div class="title">{{companyemployees}}</div>
                                            </div>
                                            <div class="col-sm-2 second d-flex align-items-center">
                                                <div class="icon d-flex align-items-center">
                                                    <img v-bind:src="$api_url+'/images/employees_icon.png'"  class="img-fluid"  />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="col-sm-4">
                                <div class="row">
                                    <div class=" col-sm-12">
                                        <div class="row dashboard_overview_card">
                                            <div class="col-sm-10 first">
                                                <div class="sub-title">Total Active Employees </div>
                                                <div class="title">{{ activeemployees }}</div>
                                            </div>
                                            <div class="col-sm-2 second d-flex align-items-center ">
                                                <div class="icon d-flex align-items-center">
                                                    <img v-bind:src="$api_url+'/images/check_active.png'"  class="img-fluid check_icon"  />
                                                    <img v-bind:src="$api_url+'/images/employees_icon.png'"  class="img-fluid"  />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="row dashboard_overview_card">
                                            <div class="col-sm-10 first">
                                                <div class="sub-title">Pay Slips generated Last Payrun | <span>{{dashboardTotals.month}}</span></div>
                                                <template v-if="dashboardTotals.payslips_count > 0">
                                                    <div class="title"> {{dashboardTotals.payslips_count}}</div>
                                                </template>
                                                <template v-else>
                                                    <div class="title">0</div>
                                                </template>

                                            </div>
                                            <div class="col-sm-2 second d-flex align-items-center">
                                                <div class="icon d-flex align-items-center">
                                                    <img v-bind:src="$api_url+'/images/last_payrun.png'"  class="img-fluid"  />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="row dashboard_overview_card">
                                            <div class="col-sm-10 first">
                                                <div class="sub-title">Gross Salary in Last Payrun | <span>{{dashboardTotals.month}}</span></div>
                                                <div class="title">&#2547; {{formatMoney(dashboardTotals.gross_salary)}}</div>
                                            </div>
                                            <div class="col-sm-2 second d-flex align-items-center">
                                                <div class="icon d-flex align-items-center">
                                                    <img v-bind:src="$api_url+'/images/gross_salary_last_payrun.png'"  class="img-fluid"  />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="row dashboard_overview_card">
                                            <div class="col-sm-10 first">
                                                <div class="sub-title">Tax Deducted at Source in Last Payrun | <span>{{dashboardTotals.month}}</span></div>
                                                <div class="title">&#2547; {{formatMoney(dashboardTotals.payrun_tds)}}</div>
                                            </div>
                                            <div class="col-sm-2 second d-flex align-items-center">
                                                <div class="icon d-flex align-items-center">
                                                    <img v-bind:src="$api_url+'/images/annual_tds.png'"  class="img-fluid"  />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>

            <!-- Abdullah -- This is the 2nd markup chnages with new classes and stracture  -->
            <div class="ibox col-md-12 border-0 module_link_container">

                <div class="row p-4">
                    <div class="col-sm-12 row m-0 py-0 px-0 d-links ">

                        <div class="company-dashboard-items-wrapper">
                            <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': document_err }">
                                <img v-if="document_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="HR Admin Portal Error" v-b-tooltip.left.hover="{ customClass: '' }"/> <!-- Mustafijur: 11-12-2025: Core HR to HR Admin Portal-->
                                <a :href="$api_url+'/core-hr'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_core_hr.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">HR Admin Portal</div> <!-- Mustafijur: 11-12-2025: Core HR to HR Admin Portal-->
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper">
                            <div class="d-flex align-items-center card justify-content-center" :class="{'error-found': employee_err}">
                                <img v-if="employee_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Looks like you have not added any employee yet" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                <a :href="$api_url+'/employee'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_employees.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">Employees</div>
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper">
                            <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': payroll_err }">
                                <img v-if="payroll_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Payroll Management Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                <a :href="$api_url+'/payruns'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_payroll.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">Payroll</div>
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper ">
                            <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': chalan_err }">
                                <img v-if="chalan_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Challan Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                <a :href="$api_url+'/challans'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_challan.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">Challans</div>
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper ">
                            <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': report_err }">
                                <img v-if="report_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Payroll Reporting Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                <a :href="$api_url+'/payroll-reporting'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_reporting.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">Reporting</div>
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper">
                            <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': compliance_err }">
                                <img v-if="compliance_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip"  title="Regulatory Filing Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                <a :href="$api_url+'/regulatory-filing'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                    <img v-bind:src="$api_url+'/images/module_regulatory.svg'"  class="img-fluid mb-2 module_icon"  />
                                    <div class="text-center module_label">Regulatory Filing</div>
                                </a>
                            </div>
                        </div>
                        <div class="company-dashboard-items-wrapper" v-if="addons.includes('Pf')">
                            <template v-if="addons.includes('Pf')">
                                <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': notice_err }">
                                    <img v-if="notice_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Notices Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                    <a :href="$api_url + '/pf/home'" class="text-decoration-none btn btn-default text-center w-100 p-0">

                                        <img v-bind:src="$api_url+'/images/module_pf.png'"  class="img-fluid mb-2 module_icon"  />
                                        <div class="text-center module_label">Provident Fund</div>
                                    </a>
                                </div>
                            </template>
                        </div>

                        <div class="company-dashboard-items-wrapper" v-if="addons.includes('Gf')">
                            <template v-if="addons.includes('Gf')">
                                <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': notice_err }">
                                    <img v-if="notice_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Notices Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                    <a :href="$api_url + '/gf/home'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                        <img v-bind:src="$api_url+'/images/module_pf.png'"  class="img-fluid mb-2 module_icon"  />
                                        <div class=" text-center module_label">Gratuity Fund</div>
                                    </a>
                                </div>
                            </template>
                        </div>

                        <div class="company-dashboard-items-wrapper" v-if="addons.includes('LeaveAttendances')">
                            <template v-if="addons.includes('LeaveAttendances')">
                                <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': leave_attendance_err }">
                                    <img v-if="leave_attendance_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Leave Attendance Module Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                    <a :href="$api_url + '/leave-attendances'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                        <img v-bind:src="$api_url+'/images/module_leave.png'"  class="img-fluid mb-2 module_icon"  />
                                        <div class="text-center module_label">Leave &amp; Attendances </div>
                                    </a>
                                </div>
                            </template>
                        </div>

                        <div class="company-dashboard-items-wrapper" v-if="loan_settings == 1">
                            <template v-if="loan_settings == 1">
                                <div class="d-flex align-items-center card justify-content-center" :class="{ 'error-found': compliance_err }">
                                    <img v-if="compliance_err" v-bind:src="$api_url+'/images/alert-xxl.png'"  class="img-fluid mb-2 company-dashboard-tooltip" width="25px" title="Regulatory Filing Error" v-b-tooltip.left.hover="{ customClass: '' }"/>
                                    <a :href="$api_url+'/loan-advance/applications'" class="text-decoration-none btn btn-default text-center w-100 p-0">
                                        <img v-bind:src="$api_url+'/images/module_leave.png'"  class="img-fluid mb-2 module_icon"/>
                                        <div class="text-center module_label">Loan &amp; Advance</div>
                                    </a>
                                </div>
                            </template>
                        </div>
                        <div class="company-dashboard-last-item-wrapper">
                            <div class="inner h-100">
                                <div class="upper_content">
                                    <div class="left_content">
                                        <div class="title">Need help?</div>
                                        <div class="sub-text">Please check our User Manual or Contact our Support</div>
                                    </div>
                                    <div class="right_content">
                                        <div class="icon_wrapper">
                                            <img v-bind:src="$api_url+'/images/dash_circle.png'"  class="img-fluid module_icon"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="lower_content">
                                    <div class="lower_content_wrapper">
                                        <button class="dashboard_contact_button">Contact Support</button>
                                        <button class="dashboard_contact_button">DOCUMENTATION</button>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <!-- <template v-if="$atl_company_package_title != 'Provident Fund Only'">
               <div class="row " style="margin-top: 25px;">
                    <div class="col-6 p-1 pl-0">
                        <div class="card bar_fiscal_year h-100" >

                            <div class="card bar_fiscal_year" >
                                <template v-if="payrunsfiscalyear.length ==0">
                                    <h5 class="pt-2 text-center title">Major Payroll Movement</h5>
                                    <div class="pt-2 pb-1 text-center"><h6>No Data Available</h6></div>
                                </template>
                                <template v-else>
                                    <h5 class="pt-2 text-center title">Major Payroll Movement</h5>
                                    <div class="p-2 d-flex justify-content-between ">

                                        <div class="">
                                        <h5 class="float-left pt-2 pr-3" style="font-size:13px">Fiscal Year:</h5>
                                                <select style="font-size:13px" v-model="search.fiscal_year"  class="bar-form-select  float-right" @change="setSearchLineFixed()">
                                                    <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <template v-if="linedDatas != null">
                                        <line-chart :chart-data="linedDatas" :options= "options_line" :styles="myStyles_line"></line-chart>
                                    </template>

                                </template>
                            </div>


                        </div>
                    </div>
                    <div class="col-6 p-1 pr-0">
                        <div class="card bar_fiscal_year" >
                        <template v-if="payrunsfiscalyear.length ==0">
                            <h5 class="pt-2 text-center title">Payroll Quick Stat</h5>
                            <div class="pt-2 pb-1 text-center"><h6>No Data Available</h6></div>
                        </template>
                        <template v-else>
                            <h5 class="pt-2 text-center title">Payroll Quick Stat</h5>
                            <div class="p-2 d-flex justify-content-between ">
                                <div class="">
                                <h5 class="float-left pt-2 pr-3" style="font-size:13px">Fiscal Year:</h5>
                                        <select style="font-size:13px" v-model="search.fiscal_year"  class="bar-form-select  float-right" @change="setSearch()">
                                            <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                                    </select>
                                </div>
                            </div>

                            <template v-if="quick_start_load == false">
                                    <template v-if="barFiscalYearDatas != null ">
                                    <bar-chart :chart-data="barFiscalYearDatas" :options= "options" :styles="myStyles"  class="p-2" ></bar-chart>
                                    </template>
                            </template>
                            <template v-else>
                                <div class="trz_loader">
                                    {{load_data}}
                                    <br/>
                                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo text-center" width="100px"/>
                                </div>
                            </template>

                        </template>
                        </div>
                    </div>

                </div>
                <div class="row " style="margin-top: 25px;">

                    <div class="col-8 p-1 pl-0">
                        <payroll-run-status></payroll-run-status>

                    </div>
                    <div class="col-4 p-1 pr-0">
                        <div class="card bar_fiscal_year" >
                            <template v-if="payrunsfiscalyear.length ==0">
                                <h5 class="pt-2 text-center title">Payroll Breakup</h5>
                                    <div class="pt-2 pb-1 text-center"><h6>No Data Available</h6></div>
                            </template>
                            <template v-else>
                                <h5 class="pt-2 text-center title">Payroll Breakup</h5>
                                <div class="p-2 d-flex justify-content-between ">
                                    <div >
                                    <h5 class="pt-1 pr-3" style="font-size:13px">Fiscal Year:</h5>
                                    <select style="font-size:13px" v-model="search_doughnut.fiscal_year" class="bar-form-select" @change="setSearchDoughnut()">
                                            <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                                        </select>
                                    </div>

                                    <div>
                                    <h5 class=" pt-1 pr-3" style="font-size:13px">Month:</h5>
                                            <select style="font-size:13px" v-model="search_doughnut.month" class="bar-form-select" @change="setSearchDoughnut()">
                                            <template v-for='fmonth in payrunsfiscalmonth'>
                                                <template v-if="fmonth == 'July' ||  fmonth == 'August' ||  fmonth == 'September' ||  fmonth == 'October' || fmonth == 'November' || fmonth == 'December' ">
                                                    <option  :value='fmonth' >{{fmonth }} {{year_segment1}}</option>
                                                </template>
                                                <template v-else>
                                                    <option  :value='fmonth' >{{fmonth }} {{year_segment2}}</option>
                                                </template>
                                            </template>

                                            </select>
                                    </div>
                                </div>
                                <template v-if="doughnut_loader == false">
                                    <template v-if="doughnutDatas != null">
                                    <doughnut-chart :chart-data="doughnutDatas" :options= "options_doughnut" :styles="myStyles_doughnut"  class="pb-3"></doughnut-chart>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="trz_loader">
                                        {{load_data}}
                                        <br/>
                                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo text-center" width="100px"/>
                                    </div>
                                </template>

                            </template>
                        </div>
                    </div>

                </div>


                <div class="row " style="margin-top: 25px;">
                    <div class="col-4 p-1 pl-0 text-right">
                        <div class="card bar_fiscal_year h-100" >
                            <h5 class="pt-2 text-center title">Compliance Summary</h5>
                            <company-compliance-summary></company-compliance-summary>
                        </div>
                    </div>

                    <div class="col-8 p-1 pr-0">
                        <div class="card bar_fiscal_year" >
                            <h5 class="pt-2 text-center title">Joiners and Leavers</h5>
                            <template v-if="payrunsfiscalyear.length ==0">
                                    <div class="pt-2 pb-1 text-center"><h6>No Data Available</h6></div>
                            </template>
                            <template v-else>
                                <div class="p-2 d-flex justify-content-between ">
                                    <div class="">
                                        <h5 class="float-left pt-2 pr-3" style="font-size:13px">Fiscal Year:</h5>
                                        <select style="font-size:13px" v-model="search_join.fiscal_year" class="bar-form-select" @change="setSearchJoin()">
                                        <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                                        </select>
                                    </div>
                                </div>
                                <template v-if="lineJoiningDatas != null">
                                <line-chart :chart-data="lineJoiningDatas" :options= "joining_options_line" :styles="myStyles"  class="pb-3"></line-chart>
                                </template>
                            </template>
                        </div>
                    </div>

                </div>


                <div class="row " style="margin-top: 25px;" v-if="addons.includes('LeaveAttendances')">

                    <div class="col-6 p-1 pl-0 text-right">
                        <div class="card bar_fiscal_year ">
                            <h5 class="pt-2 text-center title">List of Approved Holidays</h5>
                            <template v-if="holidays.length ==0">
                            <div class="pt-2 pb-1 text-center"><h6>No Data Available</h6></div>
                            </template>
                            <template v-else>
                            <div class="absent_employee_list_wrapper">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item trz-dashboard-holiday-list" v-for="holiday in holidays" :key="holiday.id">
                                    <div class="">
                                        <div class="container cursor-pointer m-1 trz-holiday-dashboard" style="" :title="holiday.comment" v-b-tooltip placement="right" >
                                            <div class="col-sm-1 float-left text-center holiday_date" style="font-size: 30px;">{{formatdate2(holiday.holiday_date)}} </div>
                                            <div class="col-sm-11 float-right text-left py-1 holiday_details">
                                                <div class="">
                                                <h6 class="mb-0"> {{formatdate(holiday.holiday_date)}}</h6>
                                                <span class="text-sm text-muted">{{holiday.comment}}</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </li>
                            </ul>
                            </div>
                            </template>
                        </div>
                    </div>
                    <div class="col-6 p-1 pr-0" v-if="addons.includes('LeaveAttendances')">

                        <dashboard-leave-card></dashboard-leave-card>

                    </div>

                </div>
            </template> -->

            <!-- Abdullah bring this markup from the payroll demo  -->
            <div class="row dash_content_row">
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <major-payroll-movement :pageurl="$api_url" :payrunsfiscalyear="payrunsfiscalyear" :key="major_payroll_movement_key" ></major-payroll-movement>
                </template>
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <payroll-quick-stat :pageurl="$api_url" :payrunsfiscalyear="payrunsfiscalyear" :key="payroll_quick_stat_key" ></payroll-quick-stat>
                </template>
            </div>

  <!-- Abdullah bring this markup from the payroll demo  -->
            <div class="row dash_content_row">
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <payroll-run-status :pageurl="$api_url"></payroll-run-status>
                </template>
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <payroll-breakup :payrunsfiscalmonth="payrunsfiscalmonth" :payrunsfiscalyear="payrunsfiscalyear" :key="payroll_breakup_key" :pageurl="$api_url"></payroll-breakup>
                </template>
            </div>

            <!-- Abdullah bring this markup from the payroll demo  -->
            <div class="row dash_content_row">
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <joiner-leaver-graph :payrunsfiscalyear="payrunsfiscalyear" :key="joiner_leaver_key" :pageurl="$api_url"></joiner-leaver-graph>
                </template>
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <company-compliance-summary :pageurl="this.$api_url"></company-compliance-summary>
                </template>
            </div>

  <!-- Abdullah bring this markup from the payroll demo  -->
            <div class="row dash_content_row" v-if="addons.includes('LeaveAttendances')">
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <company-approved-holidays :holidays="this.holidays" :pageurl="$api_url"></company-approved-holidays>
                </template>
                <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <dashboard-leave-card :pageurl="$api_url"></dashboard-leave-card>
                </template>
            </div>

        </div>
        <!-- <div v-else>

            <lock-template ></lock-template>

        </div> -->

        <!-- Afrin : added 7-29-26 start -->
        <div class="row dash_content_row">
            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                <ait-breakdown :payrunsfiscalyear="payrunsfiscalyear" :key="ait_breakdown_key" :pageurl="$api_url"></ait-breakdown>
            </template>
            <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                <investment-breakdown :payrunsfiscalyear="payrunsfiscalyear" :key="investment_breakdown_key" :pageurl="$api_url"></investment-breakdown>
            </template>
        </div>
        <!-- Afrin : added 7-29-26 end -->

    </div>
</template>




<script>

  /*

    import LineChart from '../LineChart.js';
    import BarChart from '../BarChart.js';
    import DoughnutChart from '../DoughnutChart.js';
    import PolarChart from '../PolarChart.js';
    import RadarChart from '../RadarChart.js';

  */

    import moment from 'moment';
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    export default{


        components: {
            Carousel3d,
            Slide
        },
        data(){

            return {

                datacollection: null,
                doughnutDatas: null,
                linedDatas: null,
                barDatas: null,
                barDatasOpposite:null,
                polarDatas: null,
                radarDatas: null,
                barFiscalYearDatas: null,
                options:null,
                options2:null,
                options3:null,
                options_line:null,
                options_doughnut:null,
                myStyles:null,
                myStyles2:null,
                myStyles3:null,
                myStyles_line:null,
                myStyles_doughnut:null,
                fdata: [],

                cu:window.location.href,
                ce:false,
                company_id:0,
                companyname:'',
                companyaddress:'',
                companyemployees:'',
                activeemployees:'',
                companyphone:'',
                companyemail:'',
                companycontactperson:'',
                companycity:'',
                companyzip:'',
                logosrc:null,

                overview_err : false,
                employee_err : false,
                leave_attendance_err : false,
                document_err : false,
                report_err : false,
                compliance_err : false,
                notice_err : false,
                payroll_err : false,
                chalan_err : false,

                addons : [],

                employees : [],
                payrunsapproved:[],
                paginationapproved: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                per_pageapproved:10,

                payrunsfiscalyear: [],

                payrunsfiscalmonth: [],
                payrunsapproveddoughnut: [],
                payrunsapproveddoughnut2: [],
                search_doughnut:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
                search_join:{ fiscal_year:''},

                dashboardTotals: [],

                doughnut_loader:false,
                quick_start_load:false,
                load_data:'Please hold tight! We are generating your payroll stat!',

                year_segment1:'',
                year_segment2:'',
                payrun_count:0,

                payrunsdraft: [],
                draft_payruns:[],
                doughnut_length:0,
                loan_settings: '',
                joinermonth:[],

                joining_data:[],
                holidays:[],
                joining_options_line:[],
                lineJoiningDatas:null,

                // Abdullah chnaged here
                major_payroll_movement_key:0,
                payroll_quick_stat_key:1,
                dash_search:"",
                payroll_breakup_key:0,
                joiner_leaver_key:0,lineJoiningDatas:null,ait_breakdown_key:0, // Afrin : added 7-29-26 
                investment_breakdown_key:0, // Afrin : added 7-29-26


                /***** background color
                  'rgba(63, 81, 181, 0.5)',
                  'rgba(77, 182, 172, 0.5)',
                  'rgba(66, 133, 244, 0.5)',
                  'rgba(156, 39, 176, 0.5)',
                  'rgba(233, 30, 99, 0.5)',

                ***/

                // Abdullah after live added this
                decimal_point_settings: 'yes',


            }
        },
        methods:{

            formatdate:function(x)
            {
                return moment(x).format('MMMM YYYY');
            },

            formatdate2:function(x)
            {
                return moment(x).format('D');
            },

            fillData () {





                this.datacollection = {
                  labels: [this.getRandomInt(), this.getRandomInt()],
                  datasets: [
                    {
                      label: 'Data One',
                      backgroundColor: 'rgba(63, 81, 181, 0.5)',
                      data: [this.getRandomInt(), this.getRandomInt()]
                    }, {
                      label: 'Data Two',
                      backgroundColor: 'rgba(77, 182, 172, 0.5)',
                      data: [this.getRandomInt(), this.getRandomInt()]
                    }
                  ]
                }
              },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            },

            doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution){
                this.doughnutDatas = {
                  labels: ['Basic Salary', 'House Rent Allowance' ,'Conveyance Allowance'  ,'Medical Allowance' , 'Other Variable Pay', 'PF Contribution (Employer)'],
                  datasets: [{
                    label: 'My First Dataset',
                    data: [basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution],
                    backgroundColor: [
                        'rgba(66, 133, 244, 0.5)',
                        'rgba(156, 39, 176, 0.5)',
                        'rgba(63, 81, 181,0.5)',
                        'rgba(127,54,121,0.5)',
                        'rgba(77, 182, 172,0.5)',
                    ],
                    hoverOffset: 4
                  }]
                };

                 this.options_doughnut= {
                    tooltips: {
                      callbacks: {

                        label: function(tooltipItem, data) {

                          var label  = data['labels'][tooltipItem['index']];
                          var value = data['datasets'][0]['data'][tooltipItem['index']];

                          return label +'  '+Number(value).toLocaleString();
                        },

                      },

                    }


                };

                this.myStyles_doughnut={
                    height: '100%',
                    width: '100%',
                    position: 'relative',

                };
            },
            getHoliDays:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/holidays' , {
                    params: {
                        current_month: 1
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        //console.log( response.data);
                        this.holidays = response.data.holidays;
                    }

                }.bind(this));

                this.$bvModal.hide('bv-modal-govt-holiday');

            },

            barData(){
                this.barDatas={

                    labels: ['Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing'],
                    datasets: [
                        {
                            label: 'Male',
                            data: [10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30],

                            borderColor: 'rgba(77, 182, 172, 0.5)',
                            backgroundColor:'rgba(77, 182, 172, 0.2)',
                            borderWidth: 1
                        },
                         {
                            label: 'Female',
                            data: [13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33,13,23,33],
                            borderColor: 'rgba(66, 133, 244, 0.5)',
                            backgroundColor:'rgba(66, 133, 244, 0.2)',
                            borderWidth: 1
                        }
                    ]

                };


                    this.options2= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 10,
                                responsive:true,

                                }

                        }]
                    }
                };

                this.myStyles2={
                    height: '200px',
                    width: '100%',
                    position: 'relative',

                };
            },

            barFiscalYearData: function(earning,deduction,net,month){


                this.barFiscalYearDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Total Earnings',
                            data: earning,

                            borderColor: 'rgba(147,195,218)',
                            backgroundColor:'rgba(147,195,218,0.5)',
                            borderWidth: 1
                        },
                        {
                            label: 'Total Deductions',
                            data:deduction,

                            borderColor: 'rgba(255,0,0)',
                            backgroundColor:'rgba(255,0,0,0.5)',
                            borderWidth: 1
                        },
                        {
                            label: 'Net Salary',
                            data: net,

                            borderColor: 'rgba(184,139,144)',
                            backgroundColor:'rgba(184,139,144,0.5)',
                            borderWidth: 1
                        },
                    ]

                };



                this.options= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 5000000,
                                responsive:true,
                                callback: function(value, index, values) {
                                    return Number(value).toLocaleString()  ;
                                }

                                }

                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, chartData)  {

                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={
                    height: '40%',
                    width: '100%',
                    position: 'relative',

                };

            },
            lineFiscalYearData: function(fixed,variable,month){

                 this.linedDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Total Fixed Pay',
                            data: fixed,
                            borderColor: 'rgba(143,154,222)',
                            backgroundColor:'rgba(255, 255, 255,0.1)',
                            borderWidth: 3
                        },
                        {
                            label: 'Total Variable Pay',
                            data:variable,
                            borderColor: 'rgba(149,223,215)',
                            backgroundColor:'rgba(255, 255, 255,0.1)',
                            borderWidth: 3
                        },

                    ]

                };



                this.options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 5000000,
                                responsive:true,
                                callback: function(value, index, values) {
                                    return Number(value).toLocaleString()  ;
                                }

                                }

                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, chartData)  {

                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={
                    height: '400px',
                    width: '100%',
                    position: 'relative',

                };

            },

            // Abdullah after live commented this
            // formatMoney: function(amount)
            // {
            //     var money = Number(amount);
            //     money = money.toLocaleString();
            //     if(money=='NaN')
            //     money = amount;
            //     else{
            //     if(money.indexOf(".")<0)
            //     money = money+".00";
            //     }
            //     return money;
            // },

            // Abdullah after live added this for rounding to closest intijer value
            formatMoney: function(amount) {
                if (this.decimal_point_settings === 'yes') {
                    var money = Number(amount);
                    if (isNaN(money)) return amount;
                    money = money.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    return money;
                } else {
                    var money = Math.round(Number(amount));
                    if (isNaN(money)) return amount;
                    return money.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    });
                }
            },

            lineJoiningData: function(fixed,variable,month,step_size){

                 this.lineJoiningDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Joiners',
                            data: fixed,

                            borderColor: 'rgba(149,223,215)',
                            backgroundColor:'rgba(149,223,215,0.4)',
                            borderWidth: 3
                        },
                        {
                            label: 'Leavers',
                            data:variable,

                            borderColor: 'rgba(143,154,222)',
                            backgroundColor:'rgba(143,154,222,0.4)',
                            borderWidth: 3
                        },

                    ]

                };

                this.joining_options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 20,

                                }

                        }]
                    }
                };

                this.myStyles={
                    height: '400px',
                    width: '100%',
                    position: 'relative',

                };

            },

            barDataOpposite(){
                this.barDatasOpposite={

                    labels:  ['Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing','Finance', 'HR&Admin', 'Marketing'],
                    datasets: [
                        {
                            label: 'Male',
                            data: [10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30,10,20,30],

                            borderColor: 'rgba(77, 182, 172, 0.5)',
                            backgroundColor:'rgba(77, 182, 172, 0.2)',
                            borderWidth: 1
                        }, {
                            label: 'Female',
                            data: [-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30,-10,-20,-30],
                            borderColor: 'rgba(66, 133, 244, 0.5)',
                            backgroundColor:'rgba(66, 133, 244, 0.2)',
                            borderWidth: 1
                        }
                    ]

                };

                    this.options3= {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepSize: 20,
                                responsive:true,

                                }

                        }]
                    }
                };

                this.myStyles3={
                    height: '200px',
                    width: '100%',
                    position: 'relative',

                };
            },

            polarData(){
                this.polarDatas = {
                  labels: [
                    'Red',
                    'Green',
                    'Yellow',
                    'Grey',
                    'Blue'
                  ],
                  datasets: [{
                    label: 'My First Dataset',
                    data: [11, 16, 7, 3, 14],
                    backgroundColor: [
                      'rgba(63, 81, 181, 0.5)',
                        'rgba(77, 182, 172, 0.5)',
                        'rgba(66, 133, 244, 0.5)',
                        'rgba(156, 39, 176, 0.5)',
                        'rgba(233, 30, 99, 0.5)',
                    ]
                  }]

                };
            },

            radarData(){
                this.radarDatas = {
                    labels: [
                        'Eating',
                        'Drinking',
                        'Sleeping',
                        'Designing',
                        'Coding',
                        'Cycling',
                        'Running'
                      ],
                      datasets: [{
                        label: 'My First Dataset',
                        data: [65, 59, 90, 81, 56, 55, 40],
                        fill: true,
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgb(255, 99, 132)',
                        pointBackgroundColor: 'rgb(255, 99, 132)',
                        pointBorderColor: '#fff',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgb(255, 99, 132)'
                      }, {
                        label: 'My Second Dataset',
                        data: [28, 48, 40, 19, 96, 27, 100],
                        fill: true,
                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
                        borderColor: 'rgb(54, 162, 235)',
                        pointBackgroundColor: 'rgb(54, 162, 235)',
                        pointBorderColor: '#fff',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgb(54, 162, 235)'
                      }]

                };
            },


            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getCompanyData:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.fdata = response.data;
                        this.company_id =  response.data.id;
                        this.logosrc = this.$api_url+'/images/company/' + response.data.logo;

                        this.companyname =  response.data.name;
                        this.companyaddress =  response.data.address;
                        this.companycity =  response.data.city;
                        this.companyzip =  response.data.zip;
                        this.companyemployees =  response.data.no_of_employees;
                        this.activeemployees =  response.data.active_employees;
                        this.companyphone =  response.data.phone;
                        this.companyemail =  response.data.email;
                        this.companycontactperson =  response.data.contact_person;

                        this.loan_settings =  response.data.loan_settings;

                        this.addons =  response.data.module_disabled;
                        if(this.addons.includes('LeaveAttendances'))
                        {
                            this.getHoliDays();
                        }


                        if(response.data.no_of_employees == 0)
                            this.employee_err = true;

                        if((response.data.tin == '') || (response.data.tax_zone == '') || (response.data.tax_circle == ''))
                            this.overview_err = true;


                        this.getAllEmployees();
                    }
                    else
                    {

                    }

                }.bind(this));

                // Abdullah after live added this
                axios.get(this.$api_url + '/password-settings', {
                    params: {}
                }).then(function(response) {
                    this.decimal_point_settings = response.data.decimal_point_settings;
                }.bind(this));

            },

            setCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                                .then(function (response)
                                {
                                    window.location.href = this.$api_url+'/'+y;

                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },


            getAllEmployees: function()
            {
                 if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/companydirectory' , {
                    params: {
                        c_id:this.company_id
                    }
                }).then(function(response){
                    if(response.data)
                    {

                        this.employees = response.data;

                    }

                }.bind(this));
            },


            getpayrunsfiscalyear: function()
            {

                //console.log('getpayrunsfiscalyear 0');
                axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
                    params: {

                  }
                }).then(function(response){
                    this.payrunsfiscalyear = response.data.data;

                    // Abdullah Added this for the new dashboard New edit
                    this.major_payroll_movement_key += 1;
                    this.payroll_quick_stat_key += 1;
                    this.payroll_breakup_key += 1;
                    // Abdullah Added this for the new dashboard end New edit
                    this.ait_breakdown_key += 1; // Afrin : added 7-29-26
                    this.investment_breakdown_key += 1; // Afrin : added 7-29-26

                    this.search.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;
                    this.search_join.fiscal_year = this.payrunsfiscalyear[0].fiscal_year;
                    this.search_doughnut.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;

                    // Abdullah Added this for the new dashboard New edit
                    this.joiner_leaver_key += 1;
                    // Abdullah Added this for the new dashboard New edit

                    // this.getpayrunsapproved();
                    // this.get_joiner_leaver_data();
                    // this.get_fixed_variable_list_graph_data();

                }.bind(this));

                //console.log('getpayrunsfiscalyear 1');
                //console.log('search_doughnut');
                //console.log(this.search_doughnut);
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: {type:'last_active'},
                    }
                }).then(function(response){


                    let payrunsapproveddoughnut2 = [];
                    payrunsapproveddoughnut2 = response.data.data;
                    let month = [];
                    let month_name =[];



                    for (var i = 0; i < payrunsapproveddoughnut2.length; i++) {

                        var month_x = payrunsapproveddoughnut2[i]['month'].replaceAll(',', '');
                        if(month.indexOf(month_x) !== -1)
                        {
                            var inx = month.indexOf(month_x);
                        }
                        else
                        {
                            month.push(payrunsapproveddoughnut2[i]['month'].replaceAll(',', ''));
                        }

                        }



                    // for (let x in payrunsapproveddoughnut2) {
                    //     console.log(x);



                    // }
                    this.payrunsfiscalmonth = month;

                    this.search_doughnut.month = response.data.data[0].month;
                    this.payroll_breakup_key += 1;  //Abdullah added this line New edit
                    // this.getpayrunsapproveddoughnut();
                  }.bind(this));



            },


              seturlSearch: function()
              {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                var get_year = String(urlParams.get('fiscal_year'));
                var get_month = String(urlParams.get('month'));

                if(get_year=="" || get_year=='null')
                    this.search.fiscal_year="";
                else
                    this.search.fiscal_year=get_year;

                if(get_year=="" || get_year=='null')
                    this.search_doughnut.fiscal_year="";
                else
                    this.search_doughnut.fiscal_year=get_year;

                if(get_month=="" || get_month=='null')
                    this.search_doughnut.month="";
                else
                    this.search_doughnut.month=get_month;


              },

            setSearchJoin: function(pageflg)
              {
                  this.get_joiner_leaver_data();
              },

            setSearch: function(pageflg)
              {
                  this.getpayrunsapproved();
              },

            setSearchLineFixed: function(pageflg)
              {
                  this.get_fixed_variable_list_graph_data();
              },
              setSearchDoughnut: function(pageflg)
              {
                  this.getpayrunsapproveddoughnut();
              },

              //18-11-21

              get_joiner_leaver_data: function()
              {


                axios.get(this.$api_url+'/pyaroll-test' , {
                      params: {

                          search_query: this.search_join,

                      }
                }).then(function(response){
                    //this.search_join.fiscal_year = '';

                    this.joining_data = response.data;

                    let joining = [];
                    let joining_final = [];
                    let leaving = [];
                    let leaving_final = [];
                    let month = [];
                    let step = 0;

                    joining = this.joining_data.join_employee;

                    leaving = this.joining_data.leave_employee;
                    let ct = 0;

                    Object.keys(joining).forEach(function(key) {


                        if(joining[key]>step)
                        {
                            step = joining[key];
                        }
                        month.push(key);
                        joining_final.push(joining[key]);

                        ct++;
                    });

                    ct = 0;
                    Object.keys(leaving).forEach(function(key) {

                        leaving_final.push(leaving[key]);

                        ct++;
                    });



                    if(ct == 12 && step>0)
                    {
                        step = step * 2;
                        step = step/10;

                        this.lineJoiningData(joining_final,leaving_final,month,step);
                    }




                  }.bind(this));
              },

            getpayrunsdraft: function()
              {
                  this.search.type = '';

                axios.get(this.$api_url+'/list-all-payruns' , {
                      params: {

                          search_query: this.search,

                      }
                }).then(function(response){
                    this.payrunsdraft = response.data.data;

                    let total_earnings = [];
                    let deduction = [];
                    let net = [];
                    let gross = [];
                    let other = [];
                    let month = [];
                    let year = [];

                    for (let x in this.payrunsdraft) {
                        gross.push(parseFloat(this.payrunsdraft[x].earnings.replaceAll(',', '')));
                        other.push(parseFloat(this.payrunsdraft[x].additions.replaceAll(',', '')));
                        total_earnings.push(parseFloat(this.payrunsdraft[x].total_earnings.replaceAll(',', '')));
                        deduction.push(parseFloat(this.payrunsdraft[x].deductions.replaceAll(',', '')));
                        net.push(parseFloat(this.payrunsdraft[x].total_pay.replaceAll(',', '')));
                        month.push(this.payrunsdraft[x].month.replaceAll(',', ''));
                        year.push(this.payrunsdraft[x].year);


                    }


                    this.draft_payruns.total_earnings = total_earnings;
                    this.draft_payruns.deduction = deduction;
                    this.draft_payruns.gross = gross;
                    this.draft_payruns.other = other;
                    this.draft_payruns.net = net;
                    this.draft_payruns.month = month;
                    this.draft_payruns.year = year;


                  }.bind(this));
              },

            getpayrunsapproved: function()
              {


                  this.quick_start_load = true;
                  //console.log('getpayrunsapproved 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search,

                    }
                }).then(function(response){
                        this.payrunsapproved = response.data.data;

                        let total_earnings = [];
                        let deduction = [];
                        let net = [];
                        let month = [];
                        let year = [];



                        for (let x in this.payrunsapproved) {

                            let total_earnings_draft = 0;
                            let deduction_draft = 0;
                            let net_draft = 0;


                            for (let y in this.draft_payruns.year) {
                                if(this.draft_payruns.year[y] == this.payrunsapproved[x].year && this.draft_payruns.month[y] == this.payrunsapproved[x].month){
                                    total_earnings_draft = total_earnings_draft + this.draft_payruns.total_earnings[y] ;
                                    deduction_draft = deduction_draft + this.draft_payruns.deduction[y] ;
                                    net_draft = net_draft + this.draft_payruns.net[y] ;

                                }

                            }

                            total_earnings_draft = total_earnings_draft + parseFloat(this.payrunsapproved[x].total_earnings.replaceAll(',', ''));
                            deduction_draft = deduction_draft + parseFloat(this.payrunsapproved[x].deductions.replaceAll(',', ''));
                            net_draft = net_draft + parseFloat(this.payrunsapproved[x].total_pay.replaceAll(',', ''));




                          var month_x = this.payrunsapproved[x].month.replaceAll(',', '');
                            if(month.indexOf(month_x) !== -1)
                            {
                                var inx = month.indexOf(month_x);
                                total_earnings[inx] = total_earnings[inx] +total_earnings_draft;
                                deduction[inx] = deduction[inx] +deduction_draft;
                                net[inx] = net[inx] +net_draft;

                            }
                            else
                            {
                                month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                                total_earnings.push(total_earnings_draft);
                                deduction.push(deduction_draft);
                                net.push(net_draft);
                                year.push(this.payrunsapproved[x].year);
                            }
                            /*total_earnings.push(total_earnings_draft);
                            deduction.push(deduction_draft);
                            net.push(net_draft);

                            month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                            year.push(this.payrunsapproved[x].year);*/

                        }


                        month.reverse();
                        total_earnings.reverse();
                        deduction.reverse();
                        net.reverse();
                        year.reverse();




                        this.barFiscalYearData(total_earnings,deduction,net,month);

                        this.quick_start_load = false;



                  }.bind(this));


              },


              get_fixed_variable_list_graph_data: function()
              {
                this.search.type = 'line_fixed';
                //console.log('get_fixed_variable_list_graph_data 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search,

                    }
                }).then(function(response){

                        this.search.type = '';

                        this.payrunsapproved = response.data.data;

                        let fixed_payment = [];
                        let variable_payment = [];
                        let net = [];
                        let month = [];
                        let year = [];



                        for (let x in this.payrunsapproved) {


                            let month_year = '';


                          var month_x = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;


                            if(month.indexOf(month_x) !== -1)
                            {
                                var inx = month.indexOf(month_x);

                                fixed_payment[inx] =  fixed_payment[inx] + parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', ''));
                                variable_payment[inx] = variable_payment[inx] + parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', ''));

                            }

                            else
                            {
                                month_year = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;
                                month.push(month_year);
                                fixed_payment.push(parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', '')));
                                variable_payment.push(parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', '')));

                            }


                        }

                        month.reverse();
                        fixed_payment.reverse();
                        variable_payment.reverse();

                        this.lineFiscalYearData(fixed_payment,variable_payment,month);

                        //this.search.type = '';



                  }.bind(this));


              },

              getpayrunsapproveddoughnut: function()
              {
                let year = '';
                let month = '';

                if(this.search_doughnut.fiscal_year==''){

                    //('getpayrunsapproveddoughnut 0');
                    axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
                    params: {

                      }
                    }).then(function(response){

                        year = response.data.data[0].fiscal_year;
                        month = this.search_doughnut.month;

                        var yr=year.split("-"); //at_edit
                        this.year_segment1=yr[0];
                        this.year_segment2=yr[1];
                        //console.log('getpayrunsapproveddoughnut 1');
                        axios.get(this.$api_url+'/list-payruns/1' , {
                            params: {
                                search_query: { fiscal_year:year,month:month},

                            }
                        }).then(function(response){
                                this.payrunsapproveddoughnut2 = response.data.data;
                                this.doughnut_length = this.payrunsapproveddoughnut2.length;

                          }.bind(this));

                    }.bind(this));
                }

               // console.log('getpayrunsapproveddoughnut 2');
                this.doughnut_loader = true;
                this.search_doughnut.type = 'pie_chart';
               // console.log(this.search_doughnut.type);
                axios.get(this.$api_url+'/list-payruns/1' , {
                    params: {
                        search_query: this.search_doughnut,

                    }
                }).then(function(response){
                        this.payrunsapproveddoughnut = response.data.data;
                        //console.log(this.payrunsapproveddoughnut.length);
                        this.search_doughnut.type = '';




                        var a = 0;
                        var b = 0;
                        var c = 0;
                        var d = 0;
                        var e = 0;
                        var f = 0;

                       // console.log('payrunsapproveddoughnut length');
                       // console.log(this.payrunsapproveddoughnut.length);


                        if(this.payrunsapproveddoughnut.length > 0 ){   ///&& this.payrunsapproveddoughnut.length < this.doughnut_length
                            var mon = this.payrunsapproveddoughnut[0].month;
                            var yea = this.payrunsapproveddoughnut[0].year;
                            for (let y in this.payrunsapproveddoughnut) {
                                if(this.payrunsapproveddoughnut[y].month == mon && this.payrunsapproveddoughnut[y].year == yea ){
                                    a = a + parseFloat(this.payrunsapproveddoughnut[y].basic_salary.replaceAll(',', ''));
                                    b = b + parseFloat(this.payrunsapproveddoughnut[y].house_rent.replaceAll(',', ''));
                                    c = c + parseFloat(this.payrunsapproveddoughnut[y].conveyance_allowance.replaceAll(',', ''));
                                    d = d + parseFloat(this.payrunsapproveddoughnut[y].medical_allowance.replaceAll(',', ''));
                                    e = e + parseFloat(this.payrunsapproveddoughnut[y].total_additions.replaceAll(',', ''));
                                    f = f + parseFloat(this.payrunsapproveddoughnut[y].pf_contribution.replaceAll(',', ''));
                                }

                            }


                            let basic_salary = a;
                            let house_rent =  b;
                            let conveyance_allowance =  c;
                            let medical_allowance=  d;
                            let total_additions =   e;
                            let pf_contribution =  f;

                            // console.log('basic_salary');
                            // console.log(basic_salary);

                            // console.log('house_rent');
                            // console.log(house_rent);

                            // console.log('conveyance_allowance');
                            // console.log(conveyance_allowance);

                            // console.log('medical_allowance');
                            // console.log(medical_allowance);

                            // console.log('total_additions');
                            // console.log(total_additions);

                            // console.log('pf_contribution');
                            // console.log(pf_contribution);



                            this.doughnutData(basic_salary,house_rent,conveyance_allowance,medical_allowance,total_additions,pf_contribution);

                        }
                        else{

                        //     let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        //     let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        //     let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        //     let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        //     let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));

                        // this.doughnutData(gross,other_allowenecs,total,deduction,net);

                        }

                        this.doughnut_loader = false;

                        /*let gross = gross_draft + parseFloat(this.payrunsapproveddoughnut[0].earnings.replaceAll(',', ''));
                        let other_allowenecs = other_draft + parseFloat(this.payrunsapproveddoughnut[0].additions.replaceAll(',', ''));
                        let total = total_earnings_draft + parseFloat(this.payrunsapproveddoughnut[0].total_earnings.replaceAll(',', ''));
                        let deduction= deduction_draft + parseFloat(this.payrunsapproveddoughnut[0].deductions.replaceAll(',', ''));
                        let net = net_draft + parseFloat(this.payrunsapproveddoughnut[0].total_pay.replaceAll(',', ''));*/




                  }.bind(this));



              },

              dashboardtotal: function()
              {
               axios.get(this.$api_url+'/dashboard_total' , {
                    params: {

                    }
                }).then(function(response){
                        this.dashboardTotals = response.data;



                  }.bind(this));
              },

        },
        created: function(){

            this.getCompanyData();
            this.fillData();
            this.barData();
            this.barDataOpposite();
            this.polarData();
            this.radarData();
            this.getpayrunsfiscalyear();
            this.seturlSearch();
            this.dashboardtotal();
            this.getpayrunsdraft();



        }
    }



</script>
<style scoped>
.trz_loader img {
	margin: 0;
	margin: 20px;
}

.trz_loader {
	width: 100%;
	text-align: center;
}

.dash-payroll-info-abs {
	position: absolute;
	/* right: ; */
	bottom: -17px;
	font-size: 12px;
	right: 0;
}
.dash-widget-info.float-right.trz_relative {
	position: relative;
}
.dash-widget-info.float-right.dash-second {
	margin-right: 10px;
}
.dashboard-card4 {
	width: 17%;
}
.dashboard-card3 {
	width: 22%;
}
.img_abs_2 {
	position: absolute;
	/* width: unset !important; */
	width: 22% !important;
}
.img_abs {
	/* width: ;/ */
	position: absolute;
	width: 16% !important;
}

@media only screen and (max-width: 1600px) {
.dashboard-card4 {
	width: 50%;
}
.img_abs_2 {
	width: 9% !important;
}

.dashboard-card3 {
	width: 33.3%;
}

.img_abs {
	width: 14% !important;
}
.col-sm-1.float-left.text-center.holiday_date {
	font-size: 20px !important;
}
}

@media only screen and (max-width: 1350px) {
.col-sm-1.float-left.text-center.holiday_date {
	font-size: 15px !important;
}
}
</style>
